import React from 'react';
import { Box, Monitor, Database } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const iconMap = {
  box: Box,
  monitor: Monitor,
  database: Database
};

const BusinessModel = () => {
  const { content } = useLanguage();
  const { businessModel } = content;

  return (
    <section id="modelo" className="py-20 lg:py-32 bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {businessModel.title}
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            {businessModel.subtitle}
          </p>
        </div>

        {/* Layers */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {businessModel.layers.map((layer, index) => {
            const Icon = iconMap[layer.icon];
            return (
              <div
                key={layer.id}
                className="relative group"
              >
                {/* Layer number */}
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg z-10">
                  {layer.id}
                </div>

                {/* Card */}
                <div className="bg-gradient-to-b from-gray-900 to-gray-950 border border-gray-800 rounded-2xl p-8 pt-12 hover:border-blue-600/50 transition-all duration-300 h-full">
                  {/* Icon */}
                  <div className="w-14 h-14 bg-blue-600/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600/20 transition-colors duration-300">
                    <Icon className="text-blue-400" size={28} />
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {layer.title}
                  </h3>
                  <h4 className="text-lg font-semibold text-blue-400 mb-4">
                    {layer.subtitle}
                  </h4>
                  <p className="text-gray-400 leading-relaxed">
                    {layer.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Closing Statement */}
        <div className="relative overflow-hidden">
          <div className="relative z-10 p-12 bg-gradient-to-r from-blue-950/40 via-gray-950/40 to-blue-950/40 border border-blue-900/30 rounded-3xl text-center">
            <div className="max-w-4xl mx-auto">
              <h3 className="text-3xl sm:text-4xl font-bold text-white mb-6">
                {businessModel.closingStatement.split('.')[0]}.
              </h3>
              <p className="text-xl text-gray-300">
                {businessModel.closingStatement.split('.').slice(1).join('.')}
              </p>
            </div>
          </div>

          {/* Background decoration */}
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl -z-10"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-800/10 rounded-full blur-3xl -z-10"></div>
        </div>
      </div>
    </section>
  );
};

export default BusinessModel;
